import React, { useState } from 'react'
import Form from './form'

export default function (props) {
  const [data, setData] = useState({ celebrity: false, enable_search: false, show_browse: false, partner: false, active: false })

  return <Form data={data} setData={setData} {...props} />
}
